module.exports = __webpack_public_path__ + "img/newchris-83.47c81091.jpg";